function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9993 15C10.9993 14.4484 10.5522 14.0013 10.0006 14.0013C9.4491 14.0013 9.002 14.4484 9.002 15C9.002 15.5515 9.4491 15.9986 10.0006 15.9986C10.5522 15.9986 10.9993 15.5515 10.9993 15ZM10.7401 7.1467C10.6901 6.78066 10.3761 6.49876 9.9964 6.49906C9.5822 6.49939 9.2467 6.83545 9.247 7.24966L9.2506 11.7513L9.2575 11.853C9.3075 12.2191 9.6215 12.501 10.0012 12.5007C10.4154 12.5003 10.7509 12.1643 10.7506 11.7501L10.747 7.24846L10.7401 7.1467ZM11.9693 1.65888C11.113 0.111083 8.8878 0.111103 8.0316 1.65893L0.286338 15.6604C-0.543222 17.16 0.541398 18.9995 2.25518 18.9995H17.7462C19.46 18.9995 20.5446 17.16 19.715 15.6603L11.9693 1.65888ZM9.3442 2.38501C9.6296 1.86907 10.3713 1.86906 10.6567 2.38499L18.4025 16.3865C18.679 16.8863 18.3175 17.4995 17.7462 17.4995H2.25518C1.68392 17.4995 1.32238 16.8863 1.5989 16.3865L9.3442 2.38501Z",
  fill: "#BA3737"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.94b7f495.svg";
export { ForwardRef as ReactComponent };